module.exports = {"533123101":"平原镇","533123102":"旧城镇","533123103":"那邦镇","533123104":"弄璋镇","533123105":"盏西镇","533123106":"卡场镇","533123107":"昔马镇","533123108":"太平镇","533123201":"新城乡","533123202":"油松岭乡","533123203":"芒章乡","533123204":"支那乡","533123205":"苏典傈僳族乡","533123206":"勐弄乡","533123207":"铜壁关乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533123.json
// module id = 2472
// module chunks = 0